// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPGLoan,
  IsApplicantSameAsPrincipal,
  HasPgFiledTaxesYearsAgo,
  RelatedPartyRelationshipEqualsTo,
} from '../rules';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

class PgFiledTaxes3YearsAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPGLoan = IsPGLoan.evaluate(data);
    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    ).evaluate(data);
    const hasPgNotFiledTaxes1YearAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(1)
      .setAnswer('No')
      .evaluate(data);

    const hasPgNotFiledTaxes2YearsAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(2)
      .setAnswer('No')
      .evaluate(data);

    const rpRelationshipIsPrincipal =
      RelatedPartyRelationshipEqualsTo.setPrincipalId(this.principalId)
        .setRelationship(RELATED_PARTY_RELATIONSHIP.PRINCIPAL)
        .evaluate(data);

    return isPGLoan &&
      rpRelationshipIsPrincipal &&
      applicantSameAsPrincipal &&
      hasPgNotFiledTaxes1YearAgo &&
      hasPgNotFiledTaxes2YearsAgo
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PgFiledTaxes3YearsAgoRuleset();
